import { render, staticRenderFns } from "./CustomFormField.vue?vue&type=template&id=5b9256fc"
import script from "./CustomFormField.vue?vue&type=script&lang=js"
export * from "./CustomFormField.vue?vue&type=script&lang=js"
import style0 from "./CustomFormField.vue?vue&type=style&index=0&id=5b9256fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VRadio,VRadioGroup,VSwitch,VTextField,VTextarea})
